import React, { useEffect, useState } from "react";
import storage from "../../../utils/storage";
import { getProducts } from "../../product/api/getProducts";
import { useAuth } from "../../../lib/auth";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { getDelverFee } from "../api/getDelverFee";
import CardProductCard from "../../product/components/cardProductCard";
import { useNavigate } from "react-router-dom";
import { createOrder } from "../api/createOrder";
import { notification } from "antd";
import { Button } from "../../../components/ui/button";
import bgImage from "../../../asset/bg.svg";
interface Product {
  id: string;
  price: string;
  category_id: string;
  index: number;
  is_active: number;
  images: { image_path: string }[];
  [key: string]: any;
}

interface CartItem {
  productId: string;
  quantity: number;
}

interface CartProduct extends Product {
  quantity: number;
}

interface ClientAddress {
  id: string;
  address: string;
  name: string;
  phone: string;
  landmark: string;
  user_id: string;
}

const CartPage = () => {
  const { user } = useAuth();
  const [cartData, setCartData] = useState<CartItem[]>([]);
  const [productsData, setProductsData] = useState<Product[]>([]);
  const [cartProducts, setCartProducts] = useState<CartProduct[]>([]);
  const [clientAddresses, setClientAddresses] = useState<ClientAddress[]>([]);
  const [selectedAddress, setSelectedAddress] = useState<ClientAddress | null>(
    null
  );
  const [api, contextHolder] = notification.useNotification();
  const [requestLoading, setRequestLoading] = useState(false);
  const [isDialogVisible, setDialogVisible] = useState(false);
  const [deliveryFee, setDeliveryFee] = useState<any>(0);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [totalAmountWithDeliver, setTotalAmountWithDeliver] =
    useState<number>(0);
  const navigate = useNavigate();

  const handleProducts = async () => {
    const response = await getProducts();
    setProductsData(response.data.products);
  };

  const fetchAddresses = async () => {
    setClientAddresses(user?.clients || []);
  };

  const fetchDeliveryFee = async () => {
    try {
      const response: any = await getDelverFee();

      setDeliveryFee(response.delivery_fee);
    } catch {}
  };

  const handleAddressChange = (addressId: string) => {
    const selected = clientAddresses.find(
      (address) => address.id === addressId
    );
    if (selected) {
      setSelectedAddress(selected);
    }
  };

  const handleDialogClose = () => {
    setDialogVisible(false);
  };

  const handleGoToSignUp = () => {
    setDialogVisible(false);
    navigate("/register");
  };

  const handleSubmitOrder = async () => {
    setRequestLoading(true);
    if (cartProducts.length === 0) {
      api.error({
        message: "السلة فارغة",
        description: "يرجى إضافة منتجات إلى السلة قبل تقديم الطلب",
        placement: "topRight",
      });
      setRequestLoading(false);
      return;
    }
    if (!selectedAddress) {
      api.error({
        message: "يرجى اختيار عنوان",
        description: `يرجى اختيار عنوان صالح`,
        placement: "topRight",
      });
      setRequestLoading(false);
      return;
    }
    // Construct the order data
    const orderData = {
      client_id: selectedAddress.id, // Assuming client_id is from selectedAddress
      products: cartProducts.map((product) => ({
        id: product.id, // Product ID
        quantity: product.quantity, // Quantity from cartProducts
      })),
    };

    try {
      // Send the order data to createOrder API
      const response = await createOrder(orderData);
      if (response) {
        api.success({
          message: "تم ارسال طلبك بنجاح",
          description: `تم إرسال طلبك بنجاح سيم التواصل معك في اقرب وقت`,
          placement: "topRight",
        });

        storage.clearCard();

        // Wait for 5 seconds, reload the page, and navigate to /home
        setTimeout(() => {
          window.location.reload(); // Reload the page
          navigate("/home"); // Navigate to /home
        }, 1000); // 5000 milliseconds = 5 seconds
      }

      // Optionally, handle post-order creation (e.g., redirect or display success message)
    } catch (error) {
      // Optionally, handle error (e.g., display error message)
    }
    setRequestLoading(false);
  };

  useEffect(() => {
    fetchDeliveryFee();
  }, []);

  useEffect(() => {
    const cart: CartItem[] = storage.getCard();
    handleProducts();
    fetchAddresses();
    setCartData(cart);
  }, []);
  const handleCardProducts = () => {
    const cart: CartItem[] = storage.getCard();
    const mergedData = cart
      .map((cartItem) => {
        const product = productsData.find(
          (product) => product.id === cartItem.productId
        );
        if (product) {
          return { ...product, quantity: cartItem.quantity };
        }
        return null;
      })
      .filter(Boolean) as CartProduct[];

    setCartProducts(mergedData);
  };
  useEffect(() => {
    handleCardProducts();
  }, [cartData, productsData]);

  const handleQuantityChange = () => {
    if (user) {
      handleTotalAmount(); // Recalculate the total amount whenever quantity changes
      handleCardProducts();
    } else {
      setDialogVisible(true);
    }
  };

  const handleTotalAmount = () => {
    const storedProducts = storage.getCard();
    let total = 0;
    if (Array.isArray(storedProducts)) {
      storedProducts.forEach((item: any) => {
        const product: any = cartProducts.find((p) => p.id === item.productId);
        if (product) {
          total += product.price * item.quantity; // Update this logic based on your price structure
        }
      });
    }
    handleCardProducts();
    setTotalAmount(total); // Assuming setTotalAmount updates the total state
    setTotalAmountWithDeliver(total + deliveryFee);
  };

  useEffect(() => {
    handleTotalAmount();
  }, [cartProducts, deliveryFee]); // Recalculate when cart products or delivery fee changes

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-no-repeat px-2 pt-16 pb-24"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: "center bottom 0rem",
      }}
    >
      {contextHolder}
      <div className=" max-w-3xl w-full rounded-lg p-6">
        {/* Cart Items */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">المشتريات</h2>
        </div>
        <div className="space-y-4">
          {cartProducts.map((product) => (
            <CardProductCard
              key={product.id}
              product={product}
              handleTotalAmount={handleTotalAmount}
              onQuantityChange={handleQuantityChange}
            />
          ))}
        </div>

        {user ? (
          <div className="mt-6">
            <h3 className="text-lg font-bold text-gray-800 text-center mb-4">
              اختر عنوان التسليم
            </h3>
            <Select onValueChange={handleAddressChange}>
              <SelectTrigger className="w-full">
                <SelectValue placeholder="اختر عنوانًا" />
              </SelectTrigger>
              <SelectContent>
                {clientAddresses.map((address) => (
                  <SelectItem key={address.id} value={address.id}>
                    {address.name} - {address.address}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ) : (
          ""
        )}

        {/* {selectedAddress && (
          <div className="mt-4 p-4 border rounded-lg bg-blue-50 shadow-md">
            <h4 className="text-lg font-bold text-blue-700 mb-2">
              تفاصيل العنوان المحدد
            </h4>
            <div className="space-y-1">
              <p className="text-sm text-gray-800">
                <span className="font-medium text-blue-700">الاسم: </span>
                {selectedAddress.name}
              </p>
              <p className="text-sm text-gray-800">
                <span className="font-medium text-blue-700">العنوان: </span>
                {selectedAddress.address}
              </p>
              <p className="text-sm text-gray-800">
                <span className="font-medium text-blue-700">معلم بارز: </span>
                {selectedAddress.landmark}
              </p>
              <p className="text-sm text-gray-800">
                <span className="font-medium text-blue-700">رقم الهاتف: </span>
                {selectedAddress.phone}
              </p>
            </div>
          </div>
        )} */}

        <div className="mt-6 p-4 flex justify-between w-full rounded-lg text-center">
          <p className="text-xl font-semibold ">{`${deliveryFee} IQ`}</p>{" "}
          <label className="block text-lg font-bold ">رسوم التوصيل</label>
        </div>
        {/* <div className="mt-6 p-4 bg-gray-100 rounded-lg text-center shadow-sm">
          <label className="block text-lg font-bold text-gray-800">
            المجموع الكلي مع رسوم التوصيل
          </label>
          <p className="text-xl font-semibold text-blue-600">
            {`${totalAmountWithDeliver.toFixed(2)} IQ`}
          </p>
        </div> */}
        <div className="mt-6 p-4 flex justify-between w-full rounded-lg text-center ">
          <p className="text-xl font-semibold">
            {`${totalAmountWithDeliver.toFixed(2)} IQ`}
          </p>
          <label className="block text-lg font-bold ">المجموع الكلي</label>
        </div>

        {/* Submit Button */}
        <div className="mt-6 text-center">
          <Button
            onClick={handleSubmitOrder}
            disabled={requestLoading || user === null}
            className="w-32"
          >
            شراء
          </Button>
        </div>
      </div>
      {isDialogVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
            <h3 className="text-xl mb-4 text-center">
              يجب عليك إنشاء حساب أولاً
            </h3>
            <div className="flex justify-center gap-4">
              <button
                onClick={handleGoToSignUp}
                className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md"
              >
                إنشاء حساب
              </button>
              <button
                onClick={handleDialogClose}
                className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-md"
              >
                إغلاق
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartPage;
